import FormErrorMessage from '@components/FormErrorMessage';
import PlacingOrderButtons from '@components/PlacingOrderButtons';
import PlacingOrderHeader from '@components/PlacingOrderHeader';
import { ButtonType } from '@components/Button';
import { deleteWeChatForLogin } from '@api/apiClient';
import { Grid } from '@components/Grid';
import { IWeChatDeleteModalWindowProps } from '../types';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';

const WeChatDeleteModalWindow: React.FC<IWeChatDeleteModalWindowProps> = (props: IWeChatDeleteModalWindowProps): React.ReactElement => {
  const {
    handlerSetIsOpenWeChatDeleteWindow,
    refetchUseProfile
  } = props;

  const { t } = useTranslation();

  const {
    error: errorDeleteWeChatForLogin,
    isError: isErrorDeleteWeChatForLogin,
    isLoading: isLoadingDeleteWeChatForLogin,
    mutate: mutateDeleteWeChatForLogin
  } = useMutation({
    mutationFn: deleteWeChatForLogin,
    onSuccess: () => {
      onCloseModal();
      refetchUseProfile();
    }
  });

  const onCloseModal = () => {
    handlerSetIsOpenWeChatDeleteWindow(false);
  };

  return (
      <Grid>
        <PlacingOrderHeader title={t('profileData.weChatDeleteModal.title')}/>
        <PlacingOrderButtons
            buttons={[
              {
                action: mutateDeleteWeChatForLogin,
                pending: isLoadingDeleteWeChatForLogin,
                text: t('profileData.weChatDeleteModal.delete'),
                type: ButtonType.SKELETON
              }, {
                action: onCloseModal,
                disabled: isLoadingDeleteWeChatForLogin,
                text: t('profileData.weChatDeleteModal.no'),
                type: ButtonType.BLOCK
              }
            ]}
            reverse
        />
        {isErrorDeleteWeChatForLogin && <FormErrorMessage error={errorDeleteWeChatForLogin}/>}
      </Grid>
  );
};

export default WeChatDeleteModalWindow;